import React from "react";
import { Switch, Route, Router } from "react-router-dom";
import history from "../../../Assets/Lib/history";
import List from "./List";
import Add from "./Add";
import Edit from "./Edit";

const Items = () => {
  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/admin/therapists/items" component={List} />
        <Route path="/admin/therapists/items/new" component={Add} />
        <Route path="/admin/therapists/items/:id" component={Edit} />
      </Switch>
    </Router>
  );
};
export default Items;
